// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as homeRouteRouteImport } from './routes/(home)/route'
import { Route as homeIndexRouteImport } from './routes/(home)/index'
import { Route as homeErrorRouteImport } from './routes/(home)/error'
import { Route as DocsSplatRouteImport } from './routes/docs/$'
import { Route as homeBlogIndexRouteImport } from './routes/(home)/blog/index'
import { Route as homeBlogSlugRouteImport } from './routes/(home)/blog/$slug'

const homeRouteRoute = homeRouteRouteImport.update({
            id: '/(home)',getParentRoute: () => rootRouteImport
          })
const homeIndexRoute = homeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => homeRouteRoute
          })
const homeErrorRoute = homeErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => homeRouteRoute
          })
const DocsSplatRoute = DocsSplatRouteImport.update({
            id: '/docs/$',path: '/docs/$',getParentRoute: () => rootRouteImport
          })
const homeBlogIndexRoute = homeBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => homeRouteRoute
          })
const homeBlogSlugRoute = homeBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => homeRouteRoute
          })





const homeRouteRouteChildren = {
  homeErrorRoute: homeErrorRoute,homeIndexRoute: homeIndexRoute,homeBlogSlugRoute: homeBlogSlugRoute,homeBlogIndexRoute: homeBlogIndexRoute
}

const homeRouteRouteWithChildren = homeRouteRoute._addFileChildren(homeRouteRouteChildren)

const rootRouteChildren = {
  homeRouteRoute: homeRouteRouteWithChildren,DocsSplatRoute: DocsSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)